// import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import BottomFooter from '../BottomFooter'
// import Loader from '../Loader'

// function Setting() {
//     const [isLoadingMain, setIsLoadingMain] = useState(false)
//     const navigate = useNavigate()
//     return (
//         <>
//             <div className='full-wrap bottomfooter leagues'>
//                 {isLoadingMain ?
//                     <Loader />
//                     :
//                     <>
//                         <div className="balance-label position-relative">
//                             <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
//                                 <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
//                                     <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
//                                 </svg>
//                             </button>
//                             Balance Overview
//                         </div>

//                         <div className="p-3 inner-sidebar-content">
//                             <form className="p2transfer-form login-panel setting-panel">
//                                 <div className="mb-2">
//                                     <label className="form-label">Odds</label>
//                                     <div className="bg-white p-2 rounded py-3">
//                                         <div className="form-check form-switch">
//                                             <input type="checkbox" id="odds" className="form-check-input" />
//                                             <label title="" htmlFor="odds" className="form-check-label" >
//                                                 Highlight when odds change</label>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div>
//                                     <label className="form-label">Events Widget</label>
//                                     <div className="bg-white p-2 rounded py-3">
//                                         <div className="form-check form-switch">
//                                             <input type="checkbox" id="Widget" className="form-check-input" />
//                                             <label title="" htmlFor="Widget" className="form-check-label" >
//                                                 Show in Full-Markets</label>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>

//                     </>
//                 }
//             </div>
//             <BottomFooter />
//         </>
//     )
// }

// export default Setting






import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BottomFooter from '../BottomFooter'
import Loader from '../Loader'

function Setting() {
    const [isLoadingMain, setIsLoadingMain] = useState(false)
    const navigate = useNavigate()

    const [highlightOdds, setHighlightOdds] = useState(true)
    const [showFullMarkets, setShowFullMarkets] = useState(true)

    return (
        <>
            <style>
                {` .paddingZero{
                    padding-left: 0px !important;
                }
            .setting-content {
    padding: 0 1rem;
}

.setting-panel {
    width: 100%;
}

.setting-title {
    padding: 0.5rem 0;
    font-size: 15.61px;
    font-weight: 700;
    color: #000;
}

.setting-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    padding: 0 1rem;

    background: #fff;
    border-radius: 0.5rem;

    height: 43px;
}

.setting-text {
    flex: 1;
    width: 75%;

    margin-right: 1.25rem;

    font-size: 15px;
    color: #000;
}

/* Switch wrapper */
.btn-switch {
    flex-shrink: 0;
    position: relative;

    width: 56px;
    height: 32px;
}

/* Hide native checkbox */
.btn-switch__tgl {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

/* Switch background */
.btn-switch__tgl-label {
    position: relative;
    display: block;

    width: 56px;
    height: 29.14px;

    padding: 2px;

    border-radius: 16px;

    background: #d1d5db;

    cursor: pointer;

    transition: background-color 0.25s ease;
}

/* Switch circle */
.btn-switch__tgl-label::before {
    content: "";

    position: absolute;

    top: 0px;
    left: 0px;

    width: 28px;
    height: 28px;

    border-radius: 50%;

    background: #fff;

    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);

    transition: transform 0.25s ease;
}

/* Checked state */
.btn-switch__tgl:checked + .btn-switch__tgl-label {
    background: var(--bgColor);
}

.btn-switch__tgl:checked + .btn-switch__tgl-label::before {
    transform: translateX(28px);
}
`}
            </style>
            <div className='full-wrap bottomfooter leagues'>
                {isLoadingMain ?
                    <Loader />
                    :
                    <>
                        <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
                            {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
            </svg>
          </button> */}
                            Setting
                            <div className='cross-icon' onClick={() => navigate('/')} />
                        </div>

                        <div className="setting-content" style={{ background: "#EEF6FB", height: "calc(100vh - 106px)", padding: "0 1rem" }}>
                            <form className="setting-panel">

                                {/* Odds */}
                                <div className="setting-section">
                                    <div className="setting-title">
                                        Odds
                                    </div>

                                    <div className="setting-row">
                                        <span className="setting-text">
                                            Highlight when odds change
                                        </span>

                                        <div className="btn-switch">
                                            <input
                                                id="settingOdds"
                                                type="checkbox"
                                                className="btn-switch__tgl btn-switch__tgl-ios"
                                                checked={highlightOdds}
                                                onChange={(e) =>
                                                    setHighlightOdds(e.target.checked)
                                                }
                                            />

                                            <label
                                                htmlFor="settingOdds"
                                                className={`btn-switch__tgl-label ${highlightOdds ? 'checked' : ''}`}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Events Widget */}
                                <div className="setting-section">
                                    <div className="setting-title">
                                        Events Widget
                                    </div>

                                    <div className="setting-row">
                                        <span className="setting-text">
                                            Show in Full-Markets
                                        </span>

                                        <div className="btn-switch">
                                            <input
                                                id="settingEventsWidget"
                                                type="checkbox"
                                                className="btn-switch__tgl btn-switch__tgl-ios"
                                                checked={showFullMarkets}
                                                onChange={(e) =>
                                                    setShowFullMarkets(e.target.checked)
                                                }
                                            />

                                            <label
                                                htmlFor="settingEventsWidget"
                                                className={`btn-switch__tgl-label ${showFullMarkets ? 'checked' : ''}`}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default Setting